export const TARGET_VS_ACHIEVEMENT_GO_BUTTON_API = "TARGET_VS_ACHIEVEMENT_GO_BUTTON_API"
export const TARGET_VS_ACHIEVEMENT_GO_BUTTON_API_SUCCESS = "TARGET_VS_ACHIEVEMENT_GO_BUTTON_API_SUCCESS"


export const TARGET_VS_ACHIEVEMENT_GROUP_GO_BUTTON_API = "TARGET_VS_ACHIEVEMENT_GROUP_GO_BUTTON_API"
export const TARGET_VS_ACHIEVEMENT_GROUP_GO_BUTTON_API_SUCCESS = "TARGET_VS_ACHIEVEMENT_GROUP_GO_BUTTON_API_SUCCESS"

export const GET_CLUSTER_PARTY_DROPDOWN = "GET_CLUSTER_PARTY_DROPDOWN";
export const GET_CLUSTER_PARTY_DROPDOWN_SUCCESS = "GET_CLUSTER_PARTY_DROPDOWN_SUCCESS";




export const TARGET_VS_ACHIEVEMENT_API_ERRORACTION = "TARGET_VS_ACHIEVEMENT_API_ERRORACTION"